import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchAdminChatList = (
  options?: UseMutationOptions<any, any, any, any>
) => {
  return useMutation(fetchAdminChatList, options);
};

export const useGetUsersForNewChat = (options?: UseMutationOptions<any, any, { searchFilter: string,  userFlag: string }, any>) => {
    return useMutation(
        async ({ searchFilter,  userFlag }: { searchFilter: string, userFlag?: string }) => {
            return await get("chat/adminmessages-newusers/list?searchFilter=" + searchFilter + "&userFlag=" + userFlag);
        },
        options
    );
};

export const fetchAdminChatList = async ({
  searchFilter,
  userFlag,
}: {
  searchFilter: string;
  userFlag: string;
}): Promise<any> => {
  return await get(`chat/adminmessages-list?searchFilter=${searchFilter}&userFlag=${userFlag}`);
};

